import * as Sentry from '@sentry/react';

export function reportError(err, context) {
  console.warn('error:', err, context);
  Sentry.captureException(err, context);
}
